<template>
  <div class="flex border-b border-gray-400 items-center p-2 last:border-b-0">
    <div class="w-12 flex justify-center mr-2 flex-shrink-0">{{shortRank(rank)}}°</div>
    <div
      class="w-16 h-16 rounded-full bg-gray-300 mr-2 bg-cover bg-center flex-shrink-0"
      :style="{
      backgroundImage: award.profile && award.profile.photoURL ? `url('${award.profile.photoURL}')` : false
    }"
    ></div>
    <div>
      <div>
        <template v-if="award.profile">{{ellipsis(award.profile.displayName, 25)}}</template>
      </div>
      <div class="flex">
        <span class="mr-2 pr-2 border-r border-gray-400">{{award.correct}} {{$t('out-of')}} 5</span>
        <span>{{time(award.time)}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rank: Number,
    award: Object,
  },
  methods: {
    ellipsis(text, length) {
      if (!text) return "";

      if (text.length > length) {
        return text.substr(0, length - 1) + "…";
      } else {
        return text;
      }
    },
    shortRank(rank) {
      if(rank < 1000) {
        return rank
      } else {
        return Math.round(rank / 1000) + 'k'
      }
    },
    time(v) {
      if (!v) return "";

      const m = Math.floor(v / 60);
      const s = Math.floor(v % 60)
        .toString()
        .padStart(2, "0");

      return `${m}:${s}`;
    },
  },
};
</script>

<style>
</style>